<template>
  <v-tooltip top>
    <span slot="activator">
      <img :draggable="false" :style="codeStyle" v-if="visualizedCodedEntry.imageBase64Value" v-bind:src="`${alertImageSourceType}${alertImageSource}`" />
      <span :style="codeStyle" v-if="!visualizedCodedEntry.imageBase64Value">{{ visualizedCodedEntry.displayName|firstCharacterFilter|upperCaseFilter}}</span>
    </span>
    <span>{{alertDisplayName}}</span>
  </v-tooltip>

</template>
<script>
export default {
  name: 'AlertVisualizedCodedEntry',
  data() {
    return {};
  },
  props: {
    alertDisplayName: {
      type: String,
      default: null
    },
    visualizedCodedEntry: Object
  },
  computed: {
    codeStyle() {
      let returnValue = null;
      if (this.visualizedCodedEntry) {
        if (this.visualizedCodedEntry.imageBase64Value) {
          returnValue = {
            height: '20px',
            verticalAlign: 'middle',
            width: '20px'
          };
        } else {
          returnValue = {
            backgroundColor: this.visualizedCodedEntry.backgroundColorHexValue
              ? this.visualizedCodedEntry.backgroundColorHexValue
              : '#ffffff',
            color: this.visualizedCodedEntry.foregroundColorHexValue
              ? this.visualizedCodedEntry.foregroundColorHexValue
              : '#000000',
            fontSize: '16px',
            fontWeight: 700,
            verticalAlign: 'middle'
          };
        }
      }
      return returnValue;
    },
    alertImageSource() {
      let returnValue = '';
      if (
        this.visualizedCodedEntry.implementationTypeCode &&
        this.visualizedCodedEntry.implementationTypeCode.code === 'SVG'
      ) {
        returnValue = atob(this.visualizedCodedEntry.imageBase64Value);
      } else {
        returnValue = this.visualizedCodedEntry.imageBase64Value;
      }
      return returnValue;
    },
    alertImageSourceType() {
      let returnValue = '';
      if (
        this.visualizedCodedEntry.implementationTypeCode &&
        this.visualizedCodedEntry.implementationTypeCode.code === 'SVG'
      ) {
        returnValue = 'data:image/svg+xml;utf8,';
      } else {
        returnValue = 'data:imagejpeg;base64,';
      }
      return returnValue;
    }
  },
  filters: {
    firstCharacterFilter: (value) => {
      let returnValue = null;
      if (value) {
        returnValue = value.charAt(0);
      }
      return returnValue;
    },
    upperCaseFilter: (value) => {
      let returnValue = null;
      if (value) {
        returnValue = value.toUpperCase();
      }
      return returnValue;
    }
  }
};
</script>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: auto;
}
</style>
